import { useAccountSubscriptionDetails } from '@frameio/plan-management/plans/hooks/useAccountSubscriptionDetails';
import { useIsEnterpriseAccount } from '@frameio/shared/plans/hooks/useIsEnterpriseAccount';
import { Box, Text, ToggleIconButton, Tooltip } from '@frameio/vapor';
import { IconInfo } from '@frameio/vapor-icons';
import { useBodyData } from './useBodyData';

export function Body({ id }: { id: string }) {
  const { text, canApprove, hasMemberLicense } = useBodyData({
    id,
  });
  const { isFreeTierPlan } = useAccountSubscriptionDetails({});
  const shouldShowMemberSeatRate = !useIsEnterpriseAccount();

  return (
    <Box paddingX={0} paddingY={2}>
      {canApprove && !hasMemberLicense && (
        <Text
          color="secondary"
          data-testid="approve-to-add-new-member-text"
          variant="body"
        >
          {text.approveToAddNewMember}
          {text.tooltip && shouldShowMemberSeatRate && !isFreeTierPlan && (
            <Tooltip
              data-testid="tooltip"
              delayIn={0}
              placement="right"
              title={text.tooltip}
            >
              <ToggleIconButton
                icon={<IconInfo size={16} />}
                label={text.tooltip}
                shape="circular"
                size="small"
                variant="ripple"
              />
            </Tooltip>
          )}
        </Text>
      )}

      {!canApprove && (
        <Text
          color="secondary"
          data-testid="upgrade-to-add-more-members-text"
          variant="body"
        >
          {text.upgradeToAddMoreMembers}
        </Text>
      )}
    </Box>
  );
}
